export const useCurrencyExchangeModalProps = () => {}